import Vue from 'vue'
import axios from 'axios';

const state = {
  submital: {},
  configurable: {},
  currentStep: 'design',
  openModalName: null,
  lastLockToggledAt: null
}

const getters = {
  submitalId (state) {
    return state.submital.id
  },
  configurableId (state) {
    return state.submital.configurable_id
  },
  configurableType (state) {
    if (state.submital.id) {
      return state.submital.configurable_type?.split('::')[1]
    }
    return ''
  },
  configurableTypeUrlString (_, getters) {
    if (!getters.configurableType) return ''

    let urlString = ''
    if (getters.configurableType === 'Seccional') {
      urlString = getters.configurableType?.toLowerCase() + 'es'
    } else if (getters.configurableType === 'AndenBorde') {
      urlString = 'anden_bordes'
    } else if (getters.configurableType === 'PuertaAutomatica') {
      urlString = 'puertas_automaticas'
    } else if (getters.configurableType === 'ControlAcceso') {
      urlString = 'controles_acceso'
    } else {
      urlString = getters.configurableType?.toLowerCase() + 's'
    }
    return urlString
  },
  configurableRouteSlugify (_, getters) {
    if (!getters.configurableType) return ''

    let urlString = ''
    if (getters.configurableType === 'Seccional') {
      urlString = getters.configurableType.toLowerCase() + 'es'
    } else if (getters.configurableType === 'AndenBorde') {
      urlString = 'andenes-de-borde'
    } else if (getters.configurableType === 'PuertaAutomatica') {
      urlString = 'puertas-automaticas'
    } else if (getters.configurableType === 'ControlAcceso') {
      urlString = 'controles-de-acceso'
    } else {
      urlString = getters.configurableType.toLowerCase() + 's'
    }
    return urlString
  },
  configuratorSteps (state, getters) {
    if (getters.configurableType === 'Cortina') {
      return [
        { en: 'design', es: 'diseño' },
        { en: 'dimensions', es: 'dimensiones' },
        { en: 'track', es: 'guías' },
        { en: 'conditions', es: 'condiciones' },
        { en: 'automation', es: 'automatización' },
        { en: 'components', es: 'componentes' },
        { en: 'electrical', es: 'eléctrica' },
        { en: 'limitations', es: 'limitaciones' }
      ]
    } else if (getters.configurableType === 'AndenBorde') {
      const steps = [
                      { en: 'design', es: 'diseño' },
                      { en: 'conditions', es: 'condiciones' },
                      { en: 'dimensions', es: 'dimensiones' },
                      { en: 'products', es: 'productos' },
                      { en: 'components', es: 'componentes' },
                      { en: 'limitations', es: 'limitaciones' }
                    ]

      if (state.configurable.leveler === 'automatico') {
        steps.splice(5, 0, { en: 'electrical', es: 'eléctrica' })
      }
      return steps
    } else if (getters.configurableType === 'PuertaAutomatica') {
      return [
        { en: 'general', es: 'Detalles generales' },
        { en: 'door_type', es: 'Tipo de puerta' },
        { en: 'dimensions', es: 'Dimensiones' },
        { en: 'limitations', es: 'Limitaciones y obstáculos' },
        { en: 'components', es: 'Accesorios' },
        { en: 'electrical', es: 'Electricidad' }
      ]
    } else if (getters.configurableType === 'ControlAcceso') {
      return [
        { en: 'general', es: 'Detalles generales' },
        { en: 'integrations', es: 'Integraciones y funciones' },
        // { en: 'dimensions', es: 'Diagrama general' },
        { en: 'network_details', es: 'Redes y Contactos' },
        { en: 'electrical', es: 'Electricidad' }
      ]
    } else if (getters.configurableType === 'Generico') {
      return [
        { en: 'general', es: 'Detalles generales' }
      ]
    }

    return [
      { en: 'not found', es: 'No disponible' },
    ]
  },
  configuratorStepNumber (state, getters) {
    return getters.configuratorSteps.findIndex(step => step.en === state.currentStep) + 1
  },
  isFirstStep (state, getters) {
    if (!state.currentStep) return false

    return getters.configuratorSteps[0].en === state.currentStep
  },
  isLastStep (state, getters) {
    if (!state.currentStep) return false

    return getters.configuratorSteps[getters.configuratorSteps.length - 1].en === state.currentStep
  },
  projectType (state) {
    if (state.submital.id) {
      return state.submital?.project?.project_type
    }
  },
  isCortina (_, getters) {
    return getters.configurableType === 'Cortina'
  },
  isSeccional (_, getters) {
    return getters.configurableType === 'Seccional'
  },
  isCorredizo (_, getters) {
    return getters.configurableType === 'Corredizo'
  },
  isAbatible (_, getters) {
    return getters.configurableType === 'Abatible'
  },
  isAndenBorde (_, getters) {
    return getters.configurableType === 'AndenBorde'
  },
  isPuertaAutomatica (_, getters) {
    return getters.configurableType === 'PuertaAutomatica'
  },
  isControlAcceso (_, getters) {
    return getters.configurableType === 'ControlAcceso'
  },
  isGenerico (_, getters) {
    return getters.configurableType === 'Generico'
  },
  submitalCategory (_, getters) {
    if (getters.configurableType === 'AndenBorde') {
      return 'Anden'
    } else if (getters.configurableType === 'PuertaAutomatica') {
      return 'Puerta'
    } else if (getters.configurableType === 'ControlAcceso') {
      return 'ControlAcceso'
    } else if (getters.configurableType === 'Generico') {
      return 'Generico'
    }

    return 'Access'
  },
  assignedColor (state, getters) {
    if (getters.isCortina && state.configurable.encargado_color === 'Accesos color original') {
      return state.configurable.color_ext
    }

    return state.configurable.color || {}
  },
  getStepAlarms: (state) => (stepName) => {
    if (!state.submital.id) return {}

    const result = {}
    const stepAlarms = state.submital.alarm_data[stepName]
    if (!stepAlarms?.alarms?.length) return result

    for (const alarm of stepAlarms.alarms) {
      for (const [key, value] of Object.entries(alarm)) {
        result[key] = value
      }
    }

    return result
  },
  requiredPhotosMap (state, getters) {
    if (!state.submital.id) return {}

    return state.submital.required_photos
  },
  requiredPhotoKeys (state, getters) {
    return Object.keys(getters.requiredPhotosMap) || []
  },
  submitalLocked (state, getters) {
    return state.submital.locked_at != null
  }
}

const actions = {
  goForward ({ state, commit, getters }) {
    const index = getters.configuratorSteps.map(s => s.en).indexOf(state.currentStep)
    const nextStep = getters.configuratorSteps[index + 1]?.en
    if (!nextStep) return

    commit('setCurrentStep', nextStep)
  },
  goBack ({ state, commit, getters }) {
    const index = getters.configuratorSteps.map(s => s.en).indexOf(state.currentStep)
    const prevStep = getters.configuratorSteps[index - 1]?.en
    if (!prevStep) return

    commit('setCurrentStep', prevStep)
  },
  clear ({ state }) { // unused
    state.configurable = {}
  },
  toggleSubmitalLock ({ commit, state }, description= '') {
    return axios.patch(`/api/production/submitals/${state.submital.id}/toggle_lock`, { description: description.trim() })
      .then(res => {
        commit('setSubmital', { ...state.submital, locked_at: res.data.locked_at })
        commit('setLastLockToggledAt', Date.now())
        return res.data
      })
  }
}

const mutations = {
  // TODO: Go over this with is partial data
  setSubmital (state, obj) {
    if (state.submital && state.submital.id && state.submital.id === obj.id) {
      Object.assign(state.submital, obj)
    } else {
      Vue.set(state, 'submital', obj)
    }
  },
  setConfigurable (state, obj) {
    if (state.configurable && state.configurable.id && state.configurable.id === obj.id) {
      Object.assign(state.configurable, obj)
    } else {
      Vue.set(state, 'configurable', obj)
    }
  },
  addSubmitalDocument (state, document) {
    state.submital.documents.push(document)
  },
  removeSubmitalDocument (state, id) {
    const index = state.submital.documents.findIndex(d => d.id === id)
    if (index > -1) {
      state.submital.documents.splice(index, 1)
    }
  },
  setCurrentStep (state, string) {
    state.currentStep = string
  },
  setOpenModalName (state, name) {
    state.openModalName = name
  },
  setLastLockToggledAt (state, value) {
    state.lastLockToggledAt = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
